import React from 'react';
import { View, StyleProp, ViewStyle } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import MyAppText from './MyAppText';

interface Props {
    messages: string[];
    style?: StyleProp<ViewStyle>;
}

export default function WarningMessage({ messages, style }: Props) {
    const { styles, theme } = useStyles(styleSheet);

    if (!messages.length) {
        return null;
    }

    return (
        <View style={[styles.container, style]}>
            <FontAwesomeIcon icon={faTriangleExclamation} color={theme.colors.warnings['300']} fontSize={16} />
            <View style={styles.textContainer}>
                {messages.map(message => (
                    <MyAppText key={message} style={styles.text}>{message}</MyAppText>
                ))}
            </View>
        </View>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 12,
        backgroundColor: theme.colors.backgrounds['BG-4'],
        borderRadius: 4,
        paddingVertical: 10,
        paddingHorizontal: 12,
    },
    textContainer: {
        flex: 1,
        flexDirection: 'column',
        gap: 4,
    },
    text: {
        color: theme.colors.warnings['300'],
        fontSize: 14,
        fontWeight: '500',
    },
}));
